// extracted by mini-css-extract-plugin
export default {"form":"GoalHierarchy_form__zKuiL","treeEditorWrapper":"GoalHierarchy_treeEditorWrapper__ndytN"};